const Index = () => import("../index.vue");
const HoursDetail = () => import("@/modules/Reports/components/DetailReports.vue");
// const Edit = () => import("@/modules/Reports/components/Edit.vue");
const HoursSummary = () => import("@/modules/Reports/EmployeeReport/HoursSummary.vue");


export default {
    path: 'reports',
    name: 'employee-reports-view',
    component: Index,
    redirect: { name: 'hours-summary' },
    children: [
        {
            name: 'hours-summary',
            path: 'summary',
            component: HoursSummary,
        },
        {
            name: 'employee-detailReport',
            path: ':id/detail',
            component: HoursDetail,
        }
    ],
    // beforeEnter: ((to, from, next) => {
    //     if (!localStorage.getItem(`${process.env.VUE_APP_STORAGE_PREFIX}Hometoken`)) {
    //       next({
    //         path: 'login',
    //       })
    //     } else {
    //       next() // make sure to always call next()!
    //     }
    // })
};